export default __webpack_public_path__ + "media/images/valid-aa3e1fbc5f5887740a8619bf0708cf4d.svg";